// extracted by mini-css-extract-plugin
export var actions = "_ve-4";
export var item = "_ve-1";
export var price = "_ve-3";
export var quantity = "_ve-2";
export var table = "_ve-0";